const regular = 400;
const bold = 'var(--global-font-weight-bold, 700)';

export const typography = {
  fontWeightRegular: regular,
  fontFamily: 'var(--global-font-family, sans-serif)',
  h1: {
    fontSize: '2.625rem', // 42px
    lineHeight: '3.625rem', // 58px
    fontWeight: bold,
  },
  h2: {
    fontSize: '2.25rem', // 36px
    lineHeight: '3.125rem', // 50px
    fontWeight: bold,
  },
  h3: {
    fontSize: '2rem', // 32px
    lineHeight: '2.75rem', // 44px
    fontWeight: bold,
  },
  h4: {
    fontSize: '1.625rem', // 26px
    lineHeight: '2.25rem', // 36px
    fontWeight: bold,
  },
  h5: {
    fontSize: '1.375rem', // 22px
    lineHeight: '1.875rem', // 30px
    fontWeight: bold,
  },
  h6: {
    fontSize: '1.125rem', // 18px
    lineHeight: '1.5rem', // 24px
    fontWeight: bold,
  },
  heading: {
    fontSize: '1.25rem', // 20px
    lineHeight: '1.875rem', // 30px,
    fontWeight: regular,
  },
  subtitle1: {
    fontSize: '1rem', // 16px
    lineHeight: '1.375rem', // 22px
    fontWeight: bold,
  },
  subtitle2: {
    fontSize: '0.875rem', // 14px
    lineHeight: '1.25rem', // 20px
    fontWeight: bold,
  },
  subtitle3: {
    fontSize: '0.75rem', // 12px
    lineHeight: '1rem', // 16px
    fontWeight: bold,
  },
  body1: {
    fontSize: '1rem', // 16px
    lineHeight: '1.375rem', // 22px
    fontWeight: regular,
  },
  body2: {
    fontSize: '0.875rem', // 14px
    lineHeight: '1.25rem', // 20px
    fontWeight: regular,
  },
  body3: {
    fontSize: '0.75rem', // 12px
    lineHeight: '1rem', // 16px
    fontWeight: regular,
  },
  button: undefined,
  overline: undefined,
  caption: undefined,
};
